import { ChangeDetectorRef, Component, HostListener, NgZone, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { AntEnvService, AuthService, DataService, HelperService } from '../../_services';
import * as _moment from 'moment';
import { empty, forkJoin, Observable } from 'rxjs';
import * as M from "materialize-css/dist/js/materialize";
import { saveAs } from 'file-saver';

// core components
// import {
//   chartOptions,
//   parseOptions,
//   chartExample1,
//   chartExample2
// } from "../../variables/charts";

@Component({
  selector: 'app-dashboardFP',
  templateUrl: './dashboardFP.component.html',
  styleUrls: ['./dashboardFP.component.scss']
})
export class DashboardFPComponent implements OnInit {

  public datasets: any;
  public data: any; dataLevel4 = [];
  public fpsensors = [];
  public salesChart;
  public clicked: boolean = true;
  public clicked1: boolean = false;

  public selectedMoment = new Date();
  public dashboardImage: any;

  constructor(
    private ngZone: NgZone,
    private changeDetector : ChangeDetectorRef,
    //public db: AngularFireDatabase,
    public svcAuth: AuthService,
    public svcData: DataService,
    //dateTimeAdapter: DateTimeAdapter<any>,
    private svcAntEnv: AntEnvService,
    private svcHelper: HelperService
  ) { 
    //dateTimeAdapter.setLocale('fr-FR'); // change locale to Japanese
    Chart.register(...registerables);
  }
  @HostListener('click', ['$event']) onClick(e) {
    if(e.target.classList.contains('li_area')){
      this.pageData.areaIndex = -1;
      var _title = e.target.innerHTML;
      this.pageData.areas.forEach((rec, iRec)=>{
        if(_title == rec.title){
          this.pageData.areaIndex = iRec
        }
      });
    }
  }

  client = '';
  pageData = {
    account: {
      fullName: 'Geek', email: 'geek@gmail.com', password: 'pwd4Geek', confirmPassword: 'pwd4Geek', contactNo: '12345678', imageUrl: '', role: 'ADMIN', title: 'Manager'
    },
    viewMode: 'LIST',
    userList: [], areas:[], areas4Occupancy:[],
    areaIndex: -1, inValue: 0, outValue: 0, occupancyValue: 0,
    data: [], hourlyDtd:[],
    cDataEntry: [], cDataExit: [], cDataOccupancy: [], cHourlyDTD: [],
    cHisEntry:[], cHisExit: [], cHisOccupancy: [],
    autoRefresh: false, isToday: false, maxOccupancy: 0
  }
  dataHis = {
    data: [], peakHourTitle: '-',
    inValue: 0, outValue: 0, maxOccupancy: 0
  };
  isLoading = true; isLoadingOccupancy = false;
  area:any;
  peakHourTitle = '-';
  isShowDTD = false;
  dwelltimeMinute = 0;
  sensorId:any;
  sensorTraffic:any;
  posX: any;
  posY: any;
  toolTips: any;

  ngOnInit() {

    this.datasets = [
      [0, 20, 10, 30, 15, 40, 20, 60, 60],
      [0, 20, 5, 25, 10, 30, 15, 40, 40]
    ];
    this.data = this.datasets[0];
    this.dataLevel4 = [
      {n:'B2', t:985, m:51.82, m_p:1, f_p:-1, ec:41.62, em:33.08, ei:22.82},
      {n:'B1', t:985, m:58.03, m_p:1, f_p:-1, ec:45.12, em:34.08, ei:18.82},
      {n:'L1', t:985, m:43.82, m_p:-1, f_p:1, ec:50.01, em:28.08, ei:19.82},
      {n:'L2', t:985, m:49.55, m_p:1, f_p:-1, ec:39.66, em:37.08, ei:20.82},
      {n:'L3', t:985, m:39.41, m_p:-1, f_p:1, ec:44.27, em:33.08, ei:20.82},
      {n:'L4', t:985, m:49.88, m_p:-1, f_p:-1, ec:37.91, em:39.08, ei:20.82}
    ];
    
    this.fpsensors = [
      {n:"CAM.1", x:"586", y:"436", e:"1086"},
      {n:"CAM.2", x:"460", y:"130", e:"1209"},
      {n:"CAM.3", x:"694", y:"125", e:"956"},
      {n:"CAM.4", x:"990", y:"420", e:"1011"},
      {n:"CAM.5", x:"566", y:"233", e:"988"},
      {n:"CAM.6", x:"692", y:"570", e:"894"},
      {n:"CAM.7", x:"1050", y:"260", e:"1024"},
      {n:"CAM.8", x:"566", y:"286", e:"1188"}
    ];
    //console.log(this.fpsensors);
    var chartOrders = document.getElementById('chart-orders');

    this.areaListLoad();
  }

  areaListLoad(){
    this.svcData.areaListAll().subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.areas = res.data;
      this.pageData.areas.push({areaId: '0', areaName: '-- ALL --'})
      //console.log(res.data);
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
      this.areaSelect(this.pageData.areas[0]);
       setTimeout(function(){
         M.FormSelect.init(document.querySelectorAll('select'), {classes:'ddl-001'});
       }, 3000);
    });
  }

  dataLoad(){
    this.loading(true);
    this.svcData.areaDetail(this.area.areaId).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      var _areaDetail = res.data;
      this.dashboardImage = res.data.imgB64;
      //console.log(_areaDetail);
      //this.ImageBaseData = _areaDetail.imgB64.toString(); // dbimg
      var _startTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      var _endTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss');
      
      this.pageData.isToday = _startTime == _moment().format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      this.pageData.maxOccupancy = 0;
      var _startTimeLastWeek = _moment(this.selectedMoment).subtract(7,'d').format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      
      this.svcData.sensorData(this.area.areaId, _startTime, _endTime).subscribe(res=>{
        this.loading(false);
        if(res.status != 'OK'){
          console.log('sensor data error### ' + this.area.areaId);
          this.showAlert(res.message);
          return;
        }
        this.pageData.inValue = 0;
        this.pageData.outValue = 0;
        this.pageData.data = res.data;
  
        this.pageData.cDataEntry = [];
        this.pageData.cDataExit = [];
        this.pageData.cDataOccupancy = [];
  
        var cIntervals = this.chartIntervals(this.area.openingTime, this.area.closingTime);
        var cHour = _moment().hour();
        cIntervals.forEach(x=>{
          this.pageData.cDataEntry.push(null);
          this.pageData.cDataExit.push(null);
          this.pageData.cDataOccupancy.push(null);
        });
        var _openingHour = _moment(this.area.openingTime).hour();
        this.pageData.data.forEach(x=>{
          this.pageData.inValue +=  x.inValue;
          this.pageData.outValue += x.outValue;
          
          var iHour = _moment(x.timestamp).hour()-_openingHour;
          if(this.pageData.isToday && iHour>cHour){
            this.pageData.cDataEntry[iHour] = null;
            this.pageData.cDataExit[iHour] = null;
          }
          else{
            this.pageData.cDataEntry[iHour] = x.inValue;
            this.pageData.cDataExit[iHour] = x.outValue;
          }
        });
        if(this.pageData.inValue<this.pageData.outValue){
          this.pageData.outValue = this.pageData.inValue;
        }
        var _occupancy = 0;
        this.pageData.cDataEntry.forEach((x, iX)=>{
          if(x==null && this.pageData.cDataExit[iX]==null) return;
          _occupancy += x - this.pageData.cDataExit[iX];
          if(_occupancy<0) _occupancy = 0;
          if(this.pageData.isToday && cHour<iX) _occupancy = null;
          this.pageData.cDataOccupancy[iX] = _occupancy;
          if(_occupancy>this.pageData.maxOccupancy) this.pageData.maxOccupancy = _occupancy;
        })
        //this.pageData.occupancyValue = this.pageData.inValue - this.pageData.outValue;
        if(this.pageData.occupancyValue<0) this.pageData.occupancyValue = 0;
  
        this.dataLoadHistory(_areaDetail);
        //this.loadSensorLocation(this.area.areaId);
        this.dataLoadPeakHour();
        if(!this.pageData.isToday){
          this.pageData.outValue = this.pageData.inValue;
          this.pageData.occupancyValue = 0;
        }
      });
      if(this.pageData.isToday){
        this.dataLoad4Occupancy();
      }
      else{
        this.pageData.areas4Occupancy = [];
      }
    });
  }
  dataLoadHistory(_areaDetail){
    var _startTime = _moment(this.selectedMoment).add('day', -7).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
    var _endTime = _moment(this.selectedMoment).add('day', -7).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss');
    this.dataHis.inValue = 0;
    this.dataHis.outValue = 0;
    this.dataHis.maxOccupancy = 0;
    this.dataHis.peakHourTitle = '-';
    var _maxIn = 0;
    var _occupancy = 0;
    this.pageData.cHisEntry = [];
    this.pageData.cHisExit = [];
    this.pageData.cHisOccupancy = [];

    this.svcData.sensorData(this.area.areaId, _startTime, _endTime).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.dataHis.data = res.data;
      this.dataHis.data.forEach(d=>{
        this.dataHis.inValue += d.inValue;
        this.dataHis.outValue += d.outValue;
        if(d.inValue > _maxIn){
          _maxIn = d.inValue;
          this.dataHis.peakHourTitle = _moment(d.timestamp).format('hh A');
        }
        _occupancy += d.inValue - d.outValue;
        if(_occupancy<0) _occupancy = 0;
        if(_occupancy>this.dataHis.maxOccupancy) this.dataHis.maxOccupancy = _occupancy;

        this.pageData.cHisEntry.push(d.inValue);
        this.pageData.cHisExit.push(d.outValue);
        this.pageData.cHisOccupancy.push(_occupancy);
      });
      //this.chartBind();
    });
  }
  dataLoadPeakHour(){
    this.peakHourTitle = '-';
    var _maxIn = 0;
    this.pageData.data.forEach(d=>{
      if(d.inValue > _maxIn){
        _maxIn = d.inValue;
        this.peakHourTitle = _moment(d.timestamp).format('hh A');
      }
    });
  }
  dataLoad4Occupancy(){
    this.pageData.areas4Occupancy = [];
    this.svcData.areaListForOccupancy().subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.areas4Occupancy = res.data;

      var _arrReq:Observable<any>[] = [];
      this.pageData.areas4Occupancy.forEach(rec=>{
        rec.occupancyTitle = '-';
        var _startTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(rec.openingTime).format('HHmmss');
        var _endTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(rec.closingTime).format('HHmmss');
        _arrReq.push(this.svcData.sensorData(rec.areaId, _startTime, _endTime));
      });
      this.isLoadingOccupancy = true;
      forkJoin(_arrReq).subscribe(resArr=>{
        this.isLoadingOccupancy = false;
        resArr.forEach((resOccupancy, i)=>{
          if(resOccupancy.status != 'OK'){
            this.showAlert(resOccupancy.message);
            return;
          }
          var _areaOccupancy = 0;
          var _dataOccupancy = resOccupancy.data;

          this.pageData.areas4Occupancy[i].inTotal = 0;
          this.pageData.areas4Occupancy[i].outTotal = 0;
          _dataOccupancy.forEach(x=>{
            _areaOccupancy += x.inValue - x.outValue;
            this.pageData.areas4Occupancy[i].inTotal += x.inValue;
            this.pageData.areas4Occupancy[i].outTotal += x.outValue;
            if(_areaOccupancy<0) _areaOccupancy = 0;
          });
          this.pageData.areas4Occupancy[i].occupancy = _areaOccupancy;
          this.pageData.areas4Occupancy[i].occupancyTitle = _areaOccupancy;
        });
        //console.log('this.client', this.client);
        if(this.client == 'DM'){
          if(this.pageData.areas4Occupancy[0].occupancy<=0 && this.pageData.areas4Occupancy[0].inTotal>0){
            this.pageData.areas4Occupancy[0].occupancy = Math.round(this.pageData.areas4Occupancy[0].inTotal*0.01);
            this.pageData.areas4Occupancy[0].occupancyTitle = this.pageData.areas4Occupancy[0].occupancy;
          }
        }
        else if(this.client == 'TB'){
          var _occBD = this.pageData.areas4Occupancy[0].occupancy;
          var _occ1 = this.pageData.areas4Occupancy[1].occupancy; // MH
          var _occ2 = this.pageData.areas4Occupancy[2].occupancy; // R
          var _occ3 = this.pageData.areas4Occupancy[3].occupancy; // SR
          this.pageData.areas4Occupancy[0].occupancy = _occ1+_occ2+_occ3;
          this.pageData.areas4Occupancy[0].occupancyTitle = _occ1+_occ2+_occ3;
          this.pageData.areas4Occupancy[1].occupancyTitle = _occ1;
          this.pageData.areas4Occupancy[2].occupancyTitle = _occ2;
          this.pageData.areas4Occupancy[3].occupancyTitle = _occ3;
          console.log('occupancy TB loaded>>>>', this.pageData.areas4Occupancy[0]);
        }
      })
    });
  }

  loadDwellTimeData(startTime: any){
    this.svcData.getDwellTimeData(startTime).subscribe(dw=> {
      if(dw.status != 'OK'){
        this.showAlert(dw.message);
        return;
      }      
      else{
      this.svcData.isShowDTD(this.area.areaId).subscribe(res => {
        if(dw.status != 'OK'){
          this.showAlert(res.message);
          return;
        }      
        else{
        this.isShowDTD = res.data[0].value == 1 ? true : false;
        }
      });
        if(dw.data.length>0){
          this.dwelltimeMinute = dw.data[0].dwellTimeMinute;
        }
      }
      
    })
  }

  loading(arg){
    var _self = this;
    this.ngZone.run(()=>{ _self.isLoading = arg; });
  }
  showAlert(msg){
    alert(msg);
    //M.toast({html: msg});
  }
  dateChange(){
    //console.log('datae change')
    //this.dataLoad();
    //this.childCountsLoad();
    this.dataLoad4Sensor();
  }
  areaSelect(arg){
    //console.log("area select")
    this.area = arg;
    //ChildCount
    this.svcData.areaDetail(arg.areaId).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.area = res.data;
      if(arg.areaId == '0'){
        this.area.areaId = '0';
        this.area.areaName = '-- ALL --';
      }
      //console.log(this.area);
      this.dataLoad4Sensor();
    });
    //CC
  }
  areaSelectDdl(arg){
    //console.log(arg);
    var _arr = this.pageData.areas.filter(x=>x.areaName == arg);
    if(_arr.length<1){
      this.showAlert('Area not found ' + arg);
      return;
    }
    this.areaSelect(_arr[0]);
  }
  chartIntervals(openingTime, closingTime){
    var arrHr = [];
    var _startHour = _moment(openingTime).hour();
    var _endHour = _moment(closingTime).hour();
    if(_endHour==0) _endHour = 23;
    //console.log(_startHour + '~' + _endHour);
    for(var i=_startHour;i<=_endHour;i++){
      arrHr.push(i + 'hr');
    }
    return arrHr;
  }
  loadSensorLocation(areaId){
    this.svcData.sensorLocation(areaId).subscribe(hdw=>{
      // this.pageData.hourlyDtd = hdw.data;
      // this.pageData.hourlyDtd.forEach(x=>{
      //   this.pageData.cHourlyDTD.push(x.dwellTimeMinute/60);
      // })
      //console.log(hdw);
      this.sensorId = hdw.data[0].sensorId;
      this.sensorTraffic = 1109;
      this.posX = hdw.data[0].x;
      this.posY = hdw.data[0].y;
      this.toolTips = this.sensorId.toString() +'-'+ this.sensorTraffic.toString();
    });
  }


  // childCountsLoad(){
  //   var _startTime = _moment(this.selectedMoment).format('YYYYMMDD090000');
  //   var _endTime = _moment(this.selectedMoment).format('YYYYMMDD235959');
    
  //   this.svcData.sensorData(this.area.areaId, _startTime, _endTime).subscribe(res=>{
  //     this.loading(false);
  //     //console.log(res);
  //     if(res.status != 'OK'){
  //       this.showAlert(res.message);
  //       return;
  //     }
  //     this.pageData.inValue = 0;
  //     this.pageData.outValue = 0;
  //     this.pageData.data = res.data;

  //     this.pageData.cDataEntry = [];
  //     this.pageData.cDataExit = [];
  //     this.pageData.cDataOccupancy = [];

  //     var cIntervals = this.chartIntervalsCC();
  //     cIntervals.forEach(x=>{
  //       this.pageData.cDataEntry.push(0);
  //       this.pageData.cDataExit.push(0);
  //       this.pageData.cDataOccupancy.push(0);
  //     })

  //     this.pageData.data.forEach(x=>{
  //       this.pageData.inValue +=  x.inValue;
        
  //       var _outValue = 0;
  //       if(this.pageData.inValue < this.pageData.outValue + x.outValue){
  //         var _xValue = (this.pageData.outValue + x.outValue) - this.pageData.inValue;
  //         _outValue = x.outValue - _xValue;
  //       }
  //       else{
  //         //this.pageData.outValue += x.outValue;
  //         _outValue = x.outValue;
  //       }
  //       this.pageData.outValue += x.outValue;

  //       var _occupancy = this.pageData.inValue - this.pageData.outValue;
  //       if(_occupancy<0) _occupancy = 0;
  //       var iHour = _moment(x.timestamp).format('H');
  //       this.pageData.cDataEntry[iHour] = x.inValue;
  //       this.pageData.cDataExit[iHour] = _outValue;
  //       this.pageData.cDataOccupancy[iHour] = _occupancy;

  //       //console.log(`${x.inValue} | ${x.outValue} --- ${_outValue}`);
  //     });
  //     if(this.pageData.inValue<this.pageData.outValue){
  //       this.pageData.inValue = this.pageData.outValue;
  //     }
  //     this.pageData.occupancyValue = this.pageData.inValue - this.pageData.outValue;
  //     if(this.pageData.occupancyValue<0) this.pageData.occupancyValue = 0;

  //     //this.chartBind();
  //   });
  // }

  chartIntervalsCC(){
    var arrHr = [];
    for(var i=0;i<24;i++){
      arrHr.push(i + 'hr');
    }
    return arrHr;
  }

  dataLoad4Sensor(){
    var _startTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(this.area.openingTime).format('HH0000');
    var _endTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(this.area.closingTime).format('HH5959');
    var _sH = _moment(this.area.openingTime).hour();
    var _eH = _moment(this.area.closingTime).hour(); 
    this.area.intervals = this.timeValueList(_sH, _eH);
    this.area.sData = this.timeValueList(_sH, _eH);
    this.area.oData = this.timeValueList(_sH, _eH);
    this.pageData.inValue = 0;
    this.pageData.outValue = 0;
    var _loadedCount = 0;
    this.isLoading = true;

    var _sensors = ['P2-EL-11','P2-EL-12','P2-WL-13','P2-WL-14','P2-NL-15','P2-NL-16','P1-EL-17','P1-EL-18','P1-WL-19',
                    'P1-WL-20','P1-ME-21','L2A-MSCP-E-29','IKP1-ME-IKCP-66','IKP1-ME-TPCP-67','IKP2-ME-IKCP-75',
                    'IKP2-ME-TPCP-76','IKP2-SL-IKCP-78','IKP2-SL-TPCP-79','IKP1-SL-IKCP-82','IKP1-SL-TPCP-83'];
    var res = this.area.sensors.filter(item => _sensors.includes(item.sensorUuid));
    //console.log(res);

    if(this.area.areaId != '0'){
      //console.log('areaid not zero')
      // this.area.sensors.forEach((s, iS) => {
        res.forEach((s, iS) => {
        this.svcData.sensorDataBySensorCC(this.area.areaId, s.sensorId, _startTime, _endTime).subscribe(d=>{
          _loadedCount++;
          if(d.status != 'OK'){
            this.showAlert(d.message);
            return;
          }
          s.data = d.data;
          s.sData = this.timeValueList(_sH, _eH);
          s.inValue = 0;
          s.outValue = 0;
          s.data.forEach(sData => {
            s.sData.forEach((t, iT) => {
              if(t.time == _moment(sData.timestamp).format('H') + 'hr'){
                t.inValue = sData.inValue;
                t.outValue = sData.outValue;
                //console.log(t);
  
                this.area.sData[iT].inValue += sData.inValue;
                this.area.sData[iT].outValue += sData.outValue;
  
                this.pageData.inValue += sData.inValue;
                this.pageData.outValue += sData.outValue;

                s.inValue += sData.inValue;
                s.outValue += sData.outValue;
              }
            });
          });
  
          if(_loadedCount == this.area.sensors.length){
            this.isLoading = false;
            var _occupancy = 0;
            this.area.sData.forEach((d, iD) => {
              _occupancy += d.inValue - d.outValue;
              if(_occupancy<0) _occupancy = 0;
              this.area.oData[iD].inValue = _occupancy;
            });
          }
        });
      });
    }
    else{
      //console.log('areaid is zero')
      var _delay = 300;
      var _self = this;
      //console.log(this.area);
      
      // this.area.sensors.forEach((s, iS) => {
        res.forEach((s, iS) => {
        setTimeout(function(){
          _self.svcData.sensorDataBySensorAloneCC(s.sensorId, _startTime, _endTime, _self.area.timezoneMinute).subscribe(d=>{
          _loadedCount++;
          //console.log(_loadedCount + ' vs ' + _self.area.sensors.length);
          if(_loadedCount == _self.area.sensors.length){
            _self.isLoading = false;
          }
          //console.log(d);
          if(d.status != 'OK'){
            _self.showAlert(d.message);
            return;
          }
          s.data = d.data;
          s.sData = _self.timeValueList(_sH, _eH);
          s.data.forEach(sData => {
            s.sData.forEach((t, iT) => {
              if(t.time == _moment(sData.timestamp).format('H') + 'hr'){
                t.inValue = sData.inValue;
                t.outValue = sData.outValue;
                //console.log(t);
  
                _self.area.sData[iT].inValue += sData.inValue;
                _self.area.sData[iT].outValue += sData.outValue;
  
                _self.pageData.inValue += sData.inValue;
                _self.pageData.outValue += sData.outValue;
              }
            });
          });
  
          if(_loadedCount == _self.area.sensors.length){
            var _occupancy = 0;
            _self.area.sData.forEach((d, iD) => {
              _occupancy += d.inValue - d.outValue;
              if(_occupancy<0) _occupancy = 0;
              _self.area.oData[iD].inValue = _occupancy;
            });
          }
        });
        }, _delay*iS);
      });
    }
    //console.log(this.area);
  }

  dataExportCsv() {
    var _nl = '\r\n';
    var csv = _moment(this.selectedMoment).format('D/MM/YYYY') + ',';
    this.area.intervals.forEach(x => {
      csv += x.time + ',,';
    });
    csv += _nl;
    csv += `${this.area.areaName},`;
    this.area.sData.forEach(d => {
      csv += `${d.inValue},${d.outValue},`;
    });
    var _sensors = ['P2-EL-11','P2-EL-12','P2-WL-13','P2-WL-14','P2-NL-15','P2-NL-16','P1-EL-17','P1-EL-18','P1-WL-19',
                    'P1-WL-20','P1-ME-21','L2A-MSCP-E-29','IKP1-ME-IKCP-66','IKP1-ME-TPCP-67','IKP2-ME-IKCP-75',
                    'IKP2-ME-TPCP-76','IKP2-SL-IKCP-78','IKP2-SL-TPCP-79','IKP1-SL-IKCP-82','IKP1-SL-TPCP-83']
    var res = this.area.sensors.filter(item => _sensors.includes(item.sensorUuid));
    //console.log(res);
    //this.area.sensors.forEach(s => {
      res.forEach(s => {
      csv += _nl + s.sensorId + ',';
      s.sData.forEach(sd => {
        csv += `${sd.inValue},${sd.outValue},`;
      });
    });
    var blob = new Blob([csv], {type: 'text/csv' })
    saveAs(blob, "exportData.csv");

  }

  timeValueList(startHour, endHour){
    var _arr = [];
    for(var i=startHour; i<=endHour; i++){
      _arr.push({time: i+'hr', inValue: 0, outValue: 0, occ: 0});
    }
    return _arr;
  }

}

